import { ProductsGrid } from "src/atoms/ProductsGrid";
import { ProductCardSkeleton } from "src/molecules/ProductCardSkeleton";

function GridSkeleton({
  numberOfItems = 72,
}: {
  numberOfItems?: number;
}): JSX.Element {
  return (
    <ProductsGrid isNewGrid>
      {[...new Array<undefined>(numberOfItems)].map((_, index) => (
        <ProductCardSkeleton key={`product-skeleton-${index}`} />
      ))}
    </ProductsGrid>
  );
}

export { GridSkeleton };
